import React from "react";
const SvgCloseCirc = props => (
  <svg viewBox="0 0 17 17" {...props}>
    <path
      style={{
        stroke: "none",
        fill: "currentColor"
      }}
      fillRule="evenodd"
      d="M10.67 11.82L8.34 9.5 6 11.82a.7.7 0 01-.99-.99L7.35 8.5 5 6.17a.7.7 0 111-1l2.33 2.34 2.33-2.33a.7.7 0 11.99.99L9.33 8.5l2.33 2.33a.7.7 0 11-.99 1m3.32-8.99a8 8 0 00-11.31 0 8 8 0 000 11.32 8 8 0 0011.31 0 8 8 0 000-11.32"
    />
  </svg>
);
export default SvgCloseCirc;
